"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
var React = require("react");
var react_redux_1 = require("react-redux");
var placeholder_view_1 = require("./containers/placeholder.view");
var placeholder_view_2 = require("./containers/placeholder.view");
var placeholder_view_3 = require("./containers/placeholder.view");
var cookies_view_1 = require("./containers/cookies/cookies.view");
var seller_tools_view_1 = require("./containers/sellerTools/seller-tools.view");
var constants_1 = require("./constants");
var PAGES = constants_1.default.PAGES;
/* eslint-enable no-unused-vars */
function tabPanelSelector(_a) {
    var route = _a.route;
    var _b = route.enter.view, view = _b === void 0 ? '' : _b;
    switch (view) {
        case PAGES.ACCOUNT: return React.createElement(placeholder_view_1.default, null);
        case PAGES.PAYMENTS: return React.createElement(placeholder_view_3.default, null);
        case PAGES.NOTIFICATIONS: return React.createElement(placeholder_view_2.default, null);
        case PAGES.COOKIES: return React.createElement(cookies_view_1.default, null);
        case PAGES.SELLER_TOOLS: return React.createElement(seller_tools_view_1.default, null);
        default: return React.createElement(placeholder_view_1.default, null);
    }
}
var mapStateToProps = function (_a) {
    var route = _a.route;
    return ({ route: route });
};
exports.default = react_redux_1.connect(mapStateToProps)(tabPanelSelector);
